"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instagram = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Instagram = function Instagram() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.333 0H6.667A6.667 6.667 0 000 6.667v10.666A6.667 6.667 0 006.667 24h10.666A6.667 6.667 0 0024 17.333V6.667A6.667 6.667 0 0017.333 0zm4.334 17.333a4.347 4.347 0 01-4.334 4.334H6.667a4.347 4.347 0 01-4.334-4.334V6.667a4.347 4.347 0 014.334-4.334h10.666a4.347 4.347 0 014.334 4.334v10.666zM18.333 7a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667zM12 6a6 6 0 106 6 5.986 5.986 0 00-6-6zm-3.667 6a3.667 3.667 0 107.334 0 3.667 3.667 0 00-7.334 0z",
    clipRule: "evenodd"
  });
};

exports.Instagram = Instagram;